export const ERROR_MESSAGES: Record<string, string> = {
    required: 'IP.VALIDATORS.REQUIRED',
    whitespace: 'IP.VALIDATORS.REQUIRED',
    maxlength: 'IP.VALIDATORS.STRING_TOO_LARGE-',
    patternNumberAndLetters: "IP.VALIDATORS.ONLY_NUMBERS_AND_LETTERS",
    patternNumberLettersAndSpaces: "IP.VALIDATORS.ONLY_NUMBERS_LETTERS_AND_SPACES",
    patternNoSpaces: "IP.VALIDATORS.NO_SPACES",
    patternNumbers: "IP.VALIDATORS.ONLY_NUMBERS",
    pattern: "IP.VALIDATORS.INVALID_FORMAT",
    amountFormat: "IP.VALIDATORS.INVALID_FORMAT",
    max: "IP.VALIDATORS.AMOUNT_TOO_BIG",
    min: "IP.VALIDATORS.PERCENTAGE_TOO_LOW",
    min1: "IP.VALIDATORS.VALUE_TOO_LOW",
    maxPercent: "IP.VALIDATORS.PERCENTAGE_TOO_HIGH",
    email: "IP.VALIDATORS.EMAIL",
    multipleEmails: "IP.VALIDATORS.MULTIPLE_MAILS",
    multiplePhones: "IP.VALIDATORS.MULTIPLE_NUMBERS",
    settlementHoldbacks_percentageAndAmount : "IP.VALIDATORS.SETTLEMENT_HOLDBACKS.PERCENTAGE_OR_AMOUNT_REQUIRED",
    settlementHoldbacks_defaultAlreadyExists : "IP.VALIDATORS.SETTLEMENT_HOLDBACKS.DEFAULT_ALREADY_EXISTS",
    codeAlreadyExists: "IP.VALIDATORS.CODE_EXIST",
    amountRangeInvalid: "IP.VALIDATORS.AMOUNT_RANGE_INVALID",
    usernameNotAvailable: "IP.VALIDATORS.USERNAME_NOT_AVAILABLE",
    twoFactorAuthInvalid: "IP.VALIDATORS.TWO_FACTOR_AUTH_INVALID"
}
